import { MatDialogRef } from '@angular/material/dialog';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { Observable, of } from 'rxjs';
import { ComponentRef } from '@angular/core';

export class DialogOrBottomSheet<T, R> {
  constructor(
    private readonly _dialogRef: MatDialogRef<T, R> | null,
    private readonly _bottomSheetRef: MatBottomSheetRef<T, R> | null
  ) {}

  public get dialogRef(): MatDialogRef<T, R> | null {
    return this._dialogRef;
  }

  public get bottomSheetRef(): MatBottomSheetRef<T, R> | null {
    return this._bottomSheetRef;
  }

  public afterClosed(): Observable<R | undefined> {
    return this._dialogRef?.afterClosed() || this._bottomSheetRef?.afterDismissed() || of(undefined);
  }

  public get componentRef(): ComponentRef<T> | null {
    return this._dialogRef?.componentRef || this._bottomSheetRef?.componentRef || null;
  }

  public close(result?: R): void {
    this._dialogRef?.close(result);
    this._bottomSheetRef?.dismiss(result);
  }

  public backdropClick(): Observable<MouseEvent | undefined> {
    return this._dialogRef?.backdropClick() || this._bottomSheetRef?.backdropClick() || of(undefined);
  }
}
